const ambulanzes = {
  title: "Ambulanzen ({{count}})",
  showAll: "Alle Ambulanzen anzeigen",
  create: "Ambulanz erstellen",
  completed: "Erledigte Ambulanzen ({{count}})",
  showCompleted: "Erledigte anzeigen",
  anonymous: "Anonym",
  types: {
    ambulanz: "Ambulanz",
    callback: "Rückruf",
    sms: "SMS",
  },
  editDialog: {
    title: "Ambulanz bearbeiten",
    successfullyUpdated: "Ambulanz wurde aktualisiert.",
  },
  actions: {
    edit: "Bearbeiten",
    claim: "Übernehmen",
    complete: "Ambulanz abschließen",
    return: "Übernahme zurückgeben",
    successfullyClaimed: "Ambulanz wurde übernommen.",
    successfullyReturned: "Übernahme wurde zurückgegeben.",
    successfullyCompleted: "Ambulanz wurde abgeschlossen.",
    alreadyClaimed: "Diese Ambulanz wurde bereits übernommen. Bitte aktualisieren Sie die Website.",
    completeConfirmTitle: "Ambulanz abschließen",
    completeConfirmText: "Möchten Sie diese Ambulanz wirklich abschließen? Dies kann nicht rückgängig gemacht werden.",
  },
  creationDialog: {
    title: "Neue Ambulanz erstellen",
    submitButton: "Ambulanz erstellen",
    successfullyAdded: "Ambulanz wurde erstellt.",
    art: "Art",
    ambulanzNumber: "Ambulanznummer",
    phone: "Telefonnummer",
    email: "E-Mail",
    note: "Notiz",
    invalidPhone: "Bitte eine gültige Telefonnummer eingeben.",
    invalidEmail: "Bitte eine gültige E-Mail-Adresse eingeben.",
  },
};

export default ambulanzes;
